import { SoProcessTypesEnum } from "@gtpl/shared-models/common-models"

export class SoProcessTypeReq{
    soProcessType : SoProcessTypesEnum
    unitId:number;
    barcode?:string;
}